/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HolderResource } from './HolderResource';

export type CriterionResource = {
    left?: HolderResource;
    operator?: CriterionResource.operator;
    right?: HolderResource;
    connector?: CriterionResource.connector;
}

export namespace CriterionResource {

    export enum operator {
        EQUALS = 'EQUALS',
        NOT_EQUALS = 'NOT_EQUALS',
        LESS_THAN = 'LESS_THAN',
        GREATER_THAN = 'GREATER_THAN',
        LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
        GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
    }

    export enum connector {
        AND = 'AND',
        OR = 'OR',
    }


}
